import "App.css";
import RouterConfig from "routes/RouterConfig";

/**
 * アプリ本体
 */
export default function App() {
  return (
    <RouterConfig />
  );
}
